import React, { useState } from 'react';
import image from '../../images/lili.png'
import Button from '../../share/button/Button';
import { useDispatch } from 'react-redux';
import { setModalStage } from '../../store/modalSlice';
import { Link } from 'react-router-dom';
import { useAccount, useConnect, useSwitchChain, useDisconnect } from 'wagmi';
import { activeChain } from '../../web3/chains';
import { isWalletConnectConfigured } from '../../web3/config';

const shortAddress = (addr) => (addr ? `${addr.slice(0, 6)}…${addr.slice(-4)}` : '');

const ConnectOldEth = () => {
    const dispatch = useDispatch();
    const { connectors, connect, isPending } = useConnect();
    const { switchChainAsync } = useSwitchChain();
    const { disconnect } = useDisconnect();
    const { isConnected, chainId, address } = useAccount();
    const [errorMessage, setErrorMessage] = useState(null);
    const [advancing, setAdvancing] = useState(false);

    // Shared "make sure we're on the right chain, then move to the next stage"
    // step. This must be reachable BOTH from a fresh connect and from an
    // already-connected wallet -- previously it only ran inside handleConnect,
    // so a user who had connected in an earlier session landed on a dead-end
    // screen with no way forward.
    const proceed = async () => {
        setErrorMessage(null);
        setAdvancing(true);
        try {
            if (chainId !== activeChain.id) {
                await switchChainAsync({ chainId: activeChain.id });
            }
            dispatch(setModalStage('OG_STATUS'));
        } catch (err) {
            setErrorMessage(
                err?.shortMessage || `Could not switch to ${activeChain.name}. Please switch networks in your wallet, then tap Continue.`
            );
        } finally {
            setAdvancing(false);
        }
    };

    const handleConnect = async (connector) => {
        setErrorMessage(null);
        try {
            await connect({ connector, chainId: activeChain.id });
        } catch (err) {
            setErrorMessage(err?.shortMessage || err?.message || 'Wallet connection was rejected.');
            return;
        }
        await proceed();
    };

    const injectedConnector = connectors.find((c) => c.id === 'injected');
    const walletConnectConnector = connectors.find((c) => c.id === 'walletConnect');

    return (
        <div className="flex flex-col items-center gap-2">
            <img src={image} className="w-[150px] sm:w-[190px] h-auto mb-2" alt="Lili" />
            <div className="flex flex-col items-center w-full gap-2">
                <h2 className="text-white uppercase text-[clamp(1.5rem,5vw,2.75rem)] text-center leading-tight">Connect to eth</h2>
                <p className="font-dang text-lg sm:text-xl md:text-[1.7rem] text-white text-center -tracking-[1px] mb-3">Connect the Ethereum wallet <br /> that held your legacy Lilverse NFT</p>

                {isConnected ? (
                    <div className="flex flex-col gap-3 items-center w-full">
                        <p className="font-mons text-white text-center text-sm sm:text-base">
                            Connected as {shortAddress(address)}
                        </p>
                        <Button onClick={proceed} disabled={advancing} size="cta">
                            {advancing ? 'Checking…' : 'Continue'}
                        </Button>
                        <button
                            onClick={() => disconnect()}
                            className="font-mons text-white underline text-sm"
                        >
                            use a different wallet
                        </button>
                    </div>
                ) : (
                    <div className="flex flex-col gap-3 items-center w-full">
                        {injectedConnector && (
                            <Button
                                onClick={() => handleConnect(injectedConnector)}
                                disabled={isPending}
                                size="cta"
                            >
                                {isPending ? 'Connecting…' : 'Connect Wallet'}
                            </Button>
                        )}
                        {walletConnectConnector && isWalletConnectConfigured && (
                            <Button
                                onClick={() => handleConnect(walletConnectConnector)}
                                disabled={isPending}
                                size="compact"
                            >
                                WalletConnect
                            </Button>
                        )}
                    </div>
                )}

                {errorMessage && (
                    <p role="alert" className="font-mons text-sm text-white bg-[#D14D4D] rounded-lg px-4 py-2 mt-3 text-center max-w-[400px]">
                        {errorMessage}
                    </p>
                )}

                <p className="font-dang text-lg sm:text-xl text-white text-center -tracking-[1px] mt-5">By connecting a wallet, you agree to our</p>
                <Link to={'/terns'} className="font-dang text-lg sm:text-xl text-white text-center -tracking-[1px] underline">Terms of Service.</Link>
            </div>
        </div>
    );
};

export default ConnectOldEth;
